(() => {
  'use strict';

  const COUNTRY_DATA = `AF|Afghanistan;AX|Åland Islands;AL|Albania;DZ|Algeria;AS|American Samoa;AD|Andorra;AO|Angola;AI|Anguilla;AQ|Antarctica;AG|Antigua and Barbuda;AR|Argentina;AM|Armenia;AW|Aruba;AU|Australia;AT|Austria;AZ|Azerbaijan;BS|Bahamas;BH|Bahrain;BD|Bangladesh;BB|Barbados;BY|Belarus;BE|Belgium;BZ|Belize;BJ|Benin;BM|Bermuda;BT|Bhutan;BO|Bolivia;BQ|Bonaire, Sint Eustatius and Saba;BA|Bosnia and Herzegovina;BW|Botswana;BV|Bouvet Island;BR|Brazil;IO|British Indian Ocean Territory;BN|Brunei;BG|Bulgaria;BF|Burkina Faso;BI|Burundi;CV|Cabo Verde;KH|Cambodia;CM|Cameroon;CA|Canada;KY|Cayman Islands;CF|Central African Republic;TD|Chad;CL|Chile;CN|China;CX|Christmas Island;CC|Cocos (Keeling) Islands;CO|Colombia;KM|Comoros;CG|Congo;CD|Congo, Democratic Republic of the;CK|Cook Islands;CR|Costa Rica;CI|Côte d’Ivoire;HR|Croatia;CU|Cuba;CW|Curaçao;CY|Cyprus;CZ|Czechia;DK|Denmark;DJ|Djibouti;DM|Dominica;DO|Dominican Republic;EC|Ecuador;EG|Egypt;SV|El Salvador;GQ|Equatorial Guinea;ER|Eritrea;EE|Estonia;SZ|Eswatini;ET|Ethiopia;FK|Falkland Islands;FO|Faroe Islands;FJ|Fiji;FI|Finland;FR|France;GF|French Guiana;PF|French Polynesia;TF|French Southern Territories;GA|Gabon;GM|Gambia;GE|Georgia;DE|Germany;GH|Ghana;GI|Gibraltar;GR|Greece;GL|Greenland;GD|Grenada;GP|Guadeloupe;GU|Guam;GT|Guatemala;GG|Guernsey;GN|Guinea;GW|Guinea-Bissau;GY|Guyana;HT|Haiti;HM|Heard Island and McDonald Islands;VA|Holy See;HN|Honduras;HK|Hong Kong;HU|Hungary;IS|Iceland;IN|India;ID|Indonesia;IR|Iran;IQ|Iraq;IE|Ireland;IM|Isle of Man;IL|Israel;IT|Italy;JM|Jamaica;JP|Japan;JE|Jersey;JO|Jordan;KZ|Kazakhstan;KE|Kenya;KI|Kiribati;KP|Korea, North;KR|Korea, South;KW|Kuwait;KG|Kyrgyzstan;LA|Laos;LV|Latvia;LB|Lebanon;LS|Lesotho;LR|Liberia;LY|Libya;LI|Liechtenstein;LT|Lithuania;LU|Luxembourg;MO|Macao;MG|Madagascar;MW|Malawi;MY|Malaysia;MV|Maldives;ML|Mali;MT|Malta;MH|Marshall Islands;MQ|Martinique;MR|Mauritania;MU|Mauritius;YT|Mayotte;MX|Mexico;FM|Micronesia;MD|Moldova;MC|Monaco;MN|Mongolia;ME|Montenegro;MS|Montserrat;MA|Morocco;MZ|Mozambique;MM|Myanmar;NA|Namibia;NR|Nauru;NP|Nepal;NL|Netherlands;NC|New Caledonia;NZ|New Zealand;NI|Nicaragua;NE|Niger;NG|Nigeria;NU|Niue;NF|Norfolk Island;MK|North Macedonia;MP|Northern Mariana Islands;NO|Norway;OM|Oman;PK|Pakistan;PW|Palau;PS|Palestine;PA|Panama;PG|Papua New Guinea;PY|Paraguay;PE|Peru;PH|Philippines;PN|Pitcairn;PL|Poland;PT|Portugal;PR|Puerto Rico;QA|Qatar;RE|Réunion;RO|Romania;RU|Russia;RW|Rwanda;BL|Saint Barthélemy;SH|Saint Helena, Ascension and Tristan da Cunha;KN|Saint Kitts and Nevis;LC|Saint Lucia;MF|Saint Martin;PM|Saint Pierre and Miquelon;VC|Saint Vincent and the Grenadines;WS|Samoa;SM|San Marino;ST|São Tomé and Príncipe;SA|Saudi Arabia;SN|Senegal;RS|Serbia;SC|Seychelles;SL|Sierra Leone;SG|Singapore;SX|Sint Maarten;SK|Slovakia;SI|Slovenia;SB|Solomon Islands;SO|Somalia;ZA|South Africa;GS|South Georgia and the South Sandwich Islands;SS|South Sudan;ES|Spain;LK|Sri Lanka;SD|Sudan;SR|Suriname;SJ|Svalbard and Jan Mayen;SE|Sweden;CH|Switzerland;SY|Syria;TW|Taiwan;TJ|Tajikistan;TZ|Tanzania;TH|Thailand;TL|Timor-Leste;TG|Togo;TK|Tokelau;TO|Tonga;TT|Trinidad and Tobago;TN|Tunisia;TR|Türkiye;TM|Turkmenistan;TC|Turks and Caicos Islands;TV|Tuvalu;UG|Uganda;UA|Ukraine;AE|United Arab Emirates;GB|United Kingdom;US|United States;UM|United States Minor Outlying Islands;UY|Uruguay;UZ|Uzbekistan;VU|Vanuatu;VE|Venezuela;VN|Vietnam;VG|Virgin Islands, British;VI|Virgin Islands, U.S.;WF|Wallis and Futuna;EH|Western Sahara;YE|Yemen;ZM|Zambia;ZW|Zimbabwe`;

  let countryLabels;
  try { countryLabels = new Intl.DisplayNames([document.documentElement.lang || 'en'], { type: 'region' }); } catch {}
  const COUNTRIES = COUNTRY_DATA.split(';').map((entry) => {
    const separator = entry.indexOf('|');
    const code = entry.slice(0, separator);
    const name = entry.slice(separator + 1);
    return { code, name, label: countryLabels?.of(code) || name };
  });
  const BRANDS = ['Vacheron Constantin', 'Audemars Piguet', 'Rolex', 'Patek Philippe', 'Richard Mille', 'Cartier', 'Other'];

  const nativeCopyFor = (root) => {
    let messages = {};
    try { messages = JSON.parse(root.querySelector('[data-gml-native-sell-copy]')?.textContent || '{}'); } catch (_error) { messages = {}; }
    return (key, values = {}) => {
      const value = typeof messages[key] === 'string' ? messages[key] : '';
      return value.replace(/\[([a-z_]+)\]/g, (token, name) => Object.prototype.hasOwnProperty.call(values, name) ? String(values[name]) : token);
    };
  };

  const normalize = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase()
    .trim();

  const stripLeadingFlag = (value) => String(value || '').replace(/^[\p{Regional_Indicator}\uFE0F\s]+/u, '');
  const escapeSelector = window.CSS && typeof window.CSS.escape === 'function'
    ? window.CSS.escape
    : (value) => String(value).replace(/[^A-Za-z0-9_-]/g, '\\$&');

  const flagFor = () => '';

  const formatBytes = (bytes) => {
    if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(bytes >= 10 * 1024 * 1024 ? 0 : 1)} MB`;
  };

  const makeIdempotencyKey = () => {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
      const bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      bytes[6] = (bytes[6] & 15) | 64;
      bytes[8] = (bytes[8] & 63) | 128;
      const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
      return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
    }
    throw new Error('Secure random generation is unavailable.');
  };

  const detectImageType = async (file) => {
    const bytes = new Uint8Array(await file.slice(0, 24).arrayBuffer());
    if (bytes[0] === 0xff && bytes[1] === 0xd8 && bytes[2] === 0xff) return 'jpeg';
    if (bytes[0] === 0x89 && bytes[1] === 0x50 && bytes[2] === 0x4e && bytes[3] === 0x47 && bytes[4] === 0x0d && bytes[5] === 0x0a && bytes[6] === 0x1a && bytes[7] === 0x0a) return 'png';
    const ascii = (start, end) => String.fromCharCode(...bytes.slice(start, end));
    if (ascii(0, 4) === 'RIFF' && ascii(8, 12) === 'WEBP') return 'webp';
    if (ascii(4, 8) === 'ftyp') {
      const brand = ascii(8, 12).toLowerCase();
      if (['heic', 'heix', 'hevc', 'hevx', 'heim', 'heis', 'mif1', 'msf1'].includes(brand)) return 'heic';
    }
    return null;
  };

  const imageDecodes = async (file) => {
    if (typeof window.createImageBitmap === 'function') {
      try {
        const bitmap = await window.createImageBitmap(file);
        const valid = bitmap.width > 0 && bitmap.height > 0;
        bitmap.close();
        return valid;
      } catch (_error) {
        return false;
      }
    }
    return new Promise((resolve) => {
      const url = URL.createObjectURL(file);
      const image = new Image();
      image.onload = () => {
        const valid = image.naturalWidth > 0 && image.naturalHeight > 0;
        URL.revokeObjectURL(url);
        resolve(valid);
      };
      image.onerror = () => {
        URL.revokeObjectURL(url);
        resolve(false);
      };
      image.src = url;
    });
  };

  const canonicalizePrice = (rawValue) => {
    const raw = String(rawValue || '').trim();
    if (!raw || /[^0-9\s.,']/u.test(raw)) return null;
    let compact = raw.replace(/[\s']/g, '');
    if (!/\d/.test(compact)) return null;
    const commas = (compact.match(/,/g) || []).length;
    const dots = (compact.match(/\./g) || []).length;
    let decimalSeparator = null;

    if (commas && dots) {
      const lastComma = compact.lastIndexOf(',');
      const lastDot = compact.lastIndexOf('.');
      const last = Math.max(lastComma, lastDot);
      const digitsAfter = compact.length - last - 1;
      if (digitsAfter >= 1 && digitsAfter <= 2) decimalSeparator = compact[last];
    } else if (commas || dots) {
      const separator = commas ? ',' : '.';
      const parts = compact.split(separator);
      if (parts.length === 2 && parts[1].length > 0 && parts[1].length !== 3) {
        decimalSeparator = separator;
      } else if (parts.length > 2) {
        const allThousands = parts.slice(1).every((part) => part.length === 3);
        if (!allThousands && parts[parts.length - 1].length <= 2) decimalSeparator = separator;
      }
    }

    let integerDigits;
    let decimalDigits = '';
    if (decimalSeparator) {
      const splitAt = compact.lastIndexOf(decimalSeparator);
      integerDigits = compact.slice(0, splitAt).replace(/[.,]/g, '');
      decimalDigits = compact.slice(splitAt + 1).replace(/[.,]/g, '');
      if (!decimalDigits || decimalDigits.length > 2) return null;
    } else {
      integerDigits = compact.replace(/[.,]/g, '');
    }
    if (!/^\d+$/.test(integerDigits) || (decimalDigits && !/^\d+$/.test(decimalDigits))) return null;
    integerDigits = integerDigits.replace(/^0+(?=\d)/, '');
    decimalDigits = decimalDigits.replace(/0+$/, '');
    const canonical = decimalDigits ? `${integerDigits}.${decimalDigits}` : integerDigits;
    if (!/[1-9]/.test(canonical)) return null;
    return canonical;
  };

  function initCountryCombobox(root, onChange) {
    const nativeText = nativeCopyFor(root);
    const wrapper = root.querySelector('[data-country-combobox]');
    if (!wrapper) return null;
    const input = wrapper.querySelector('[data-country-input]');
    const codeInput = wrapper.querySelector('[data-country-code]');
    const list = wrapper.querySelector('[data-country-list]');
    const toggle = wrapper.querySelector('[data-country-toggle]');
    let matches = COUNTRIES;
    let activeIndex = -1;

    const close = () => {
      list.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      activeIndex = -1;
    };

    const setActive = (index) => {
      const options = Array.from(list.querySelectorAll('[role="option"]'));
      if (!options.length) return;
      activeIndex = Math.max(0, Math.min(index, options.length - 1));
      options.forEach((option, optionIndex) => option.setAttribute('aria-selected', String(optionIndex === activeIndex)));
      const active = options[activeIndex];
      input.setAttribute('aria-activedescendant', active.id);
      active.scrollIntoView({ block: 'nearest' });
    };

    const select = (country) => {
      if (input.disabled) return;
      input.value = country.label;
      codeInput.value = country.code;
      input.dataset.countryName = country.name;
      input.dataset.countryLabel = country.label;
      input.setCustomValidity('');
      close();
      onChange?.();
    };

    const render = (query = '') => {
      const normalizedQuery = normalize(stripLeadingFlag(query));
      matches = normalizedQuery
        ? COUNTRIES.filter((country) => [country.label, country.name, country.code].some(value => normalize(value).startsWith(normalizedQuery)))
        : COUNTRIES;
      list.replaceChildren();
      matches.forEach((country, index) => {
        const option = document.createElement('li');
        option.id = `${list.id}-option-${index}`;
        option.setAttribute('role', 'option');
        option.setAttribute('aria-selected', 'false');
        option.dataset.code = country.code;
        option.tabIndex = -1;
        const flag = document.createElement('span');
        flag.className = 'gml-combobox__flag';
        flag.setAttribute('aria-hidden', 'true');
        flag.textContent = flagFor(country.code);
        const name = document.createElement('span');
        name.textContent = country.label;
        option.append(flag, name);
        option.addEventListener('mousedown', (event) => event.preventDefault());
        option.addEventListener('click', () => select(country));
        list.append(option);
      });
      if (!matches.length) {
        const empty = document.createElement('li');
        empty.className = 'gml-combobox__empty';
        empty.textContent = nativeText('contact_country_empty');
        list.append(empty);
      }
      list.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      activeIndex = -1;
      if (matches.length === 1 && [matches[0].label, matches[0].name].some(value => normalize(value) === normalizedQuery)) select(matches[0]);
    };

    input.addEventListener('focus', () => render(input.value));
    input.addEventListener('input', () => {
      codeInput.value = '';
      delete input.dataset.countryName;
      delete input.dataset.countryLabel;
      render(input.value);
      onChange?.();
    });
    input.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        if (list.hidden) render(input.value);
        setActive(activeIndex + 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        if (list.hidden) render(input.value);
        setActive(activeIndex <= 0 ? matches.length - 1 : activeIndex - 1);
      } else if (event.key === 'Enter' && !list.hidden) {
        if (activeIndex >= 0 && matches[activeIndex]) {
          event.preventDefault();
          select(matches[activeIndex]);
        } else if (matches.length === 1) {
          event.preventDefault();
          select(matches[0]);
        }
      } else if (event.key === 'Escape') {
        close();
      }
    });
    input.addEventListener('blur', () => {
      window.setTimeout(() => {
        const exact = COUNTRIES.find((country) => [country.label, country.name].some(value => normalize(value) === normalize(stripLeadingFlag(input.value))));
        if (!codeInput.value && exact) select(exact);
        else close();
      }, 120);
    });
    toggle.addEventListener('click', () => {
      input.focus();
      if (list.hidden) render('');
      else close();
    });

    return { input, codeInput, close, select };
  }


  function initAppConfirmation(root) {
    const app = root.querySelector('[data-gml-app-form]');
    if (!app) return;

    const watched = new WeakSet();
    const observers = [];
    let lastBanner = null;
    let frame = 0;
    let settleTimer = 0;
    let stopped = false;

    function headerOffset() {
      const header = document.querySelector('.gml-topbar') ||
        document.querySelector('#shopify-section-blano-header .site-header') ||
        document.querySelector('#shopify-section-blano-header');
      if (!header) return 24;
      const rect = header.getBoundingClientRect();
      const position = window.getComputedStyle(header).position;
      if (position === 'fixed' || position === 'sticky') {
        return Math.max(rect.height, rect.bottom, 0) + 24;
      }
      return rect.top <= 1 && rect.bottom > 0 ? rect.bottom + 24 : 24;
    }

    function showConfirmation(shadow) {
      const banner = shadow.querySelector('[data-testid="banner-success"]');
      if (!banner || banner === lastBanner || !banner.getClientRects().length) return;
      lastBanner = banner;
      cancelAnimationFrame(frame);
      clearTimeout(settleTimer);
      const heading = banner.querySelector('h1, h2, h3') || banner;
      heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: true });

      function align() {
        if (stopped || !banner.isConnected) return;
        const top = Math.max(0, window.scrollY + banner.getBoundingClientRect().top - headerOffset());
        window.scrollTo({ top, behavior: 'instant' });
      }

      frame = requestAnimationFrame(() => {
        frame = requestAnimationFrame(align);
      });
      settleTimer = window.setTimeout(align, 350);
    }

    function connect() {
      if (stopped) return;
      app.querySelectorAll('shopify-forms-embed').forEach((host) => {
        const shadow = host.shadowRoot;
        if (!shadow) return;
        if (!watched.has(shadow)) {
          watched.add(shadow);
          const observer = new MutationObserver(() => showConfirmation(shadow));
          observer.observe(shadow, { childList: true, subtree: true });
          observers.push(observer);
        }
        showConfirmation(shadow);
      });
    }

    function cancelPendingAlignment() {
      cancelAnimationFrame(frame);
      clearTimeout(settleTimer);
    }

    const mountObserver = new MutationObserver(connect);
    mountObserver.observe(app, { childList: true, subtree: true });
    const resizeObserver = new ResizeObserver(connect);
    resizeObserver.observe(app);
    window.customElements.whenDefined('shopify-forms-embed').then(connect);
    window.addEventListener('wheel', cancelPendingAlignment, { passive: true });
    window.addEventListener('touchstart', cancelPendingAlignment, { passive: true });

    function unload(event) {
      if (!event.target.contains(root)) return;
      stopped = true;
      cancelPendingAlignment();
      mountObserver.disconnect();
      resizeObserver.disconnect();
      observers.forEach((observer) => observer.disconnect());
      window.removeEventListener('wheel', cancelPendingAlignment);
      window.removeEventListener('touchstart', cancelPendingAlignment);
      document.removeEventListener('shopify:section:unload', unload);
    }
    document.addEventListener('shopify:section:unload', unload);
    connect();
  }

  function initMovementVideo(root) {
    const hero = root.querySelector('[data-gml-sell-hero]');
    if (!hero) return;
    const video = hero.querySelector('video');
    const toggle = hero.querySelector('[data-gml-video-toggle]');
    if (!video || !toggle) return;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let userPaused = motion.matches;
    let visible = true;
    video.muted = true;
    video.playsInline = true;
    toggle.hidden = false;
    function label() {
      toggle.textContent = video.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel;
    }
    function sync() {
      if (userPaused || !visible || document.hidden) {
        video.pause();
        label();
        return;
      }
      const play = video.play();
      if (play) play.catch(label);
    }
    function preference() {
      userPaused = motion.matches;
      sync();
    }
    toggle.addEventListener('click', () => {
      userPaused = !video.paused;
      sync();
    });
    video.addEventListener('play', label);
    video.addEventListener('pause', label);
    video.addEventListener('loadedmetadata', sync);
    motion.addEventListener('change', preference);
    document.addEventListener('visibilitychange', sync);
    const observer = new IntersectionObserver((entries) => {
      visible = entries[0].isIntersecting;
      sync();
    });
    observer.observe(hero);
    function unload(event) {
      if (!event.target.contains(root)) return;
      observer.disconnect();
      video.pause();
      motion.removeEventListener('change', preference);
      document.removeEventListener('visibilitychange', sync);
      document.removeEventListener('shopify:section:unload', unload);
    }
    document.addEventListener('shopify:section:unload', unload);
    sync();
  }

  function initSection(root) {
    if (root.dataset.gmlReady === 'true') return;
    root.dataset.gmlReady = 'true';
    initMovementVideo(root);
    if (root.dataset.mode === 'app') {
      initAppConfirmation(root);
      return;
    }
    if (root.dataset.mode !== 'endpoint') return;
    const nativeText = nativeCopyFor(root);

    const form = root.querySelector('[data-gml-form]');
    if (!form) return;
    const endpoint = root.dataset.endpoint.trim();
    let endpointUrl = null;
    try {
      endpointUrl = endpoint ? new URL(endpoint, window.location.origin) : null;
    } catch (_error) {
      endpointUrl = null;
    }
    const localPreview = ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname);
    const endpointIsSafe = Boolean(
      endpointUrl
      && endpointUrl.origin === window.location.origin
      && (endpointUrl.protocol === 'https:' || localPreview)
    );
    const antiBotConfigured = root.dataset.antibotConfigured === 'true';
    const privacyConfigured = root.dataset.privacyConfigured === 'true';
    const maxPhotos = Number(root.dataset.maxPhotos) || 8;
    const maxPhotoBytes = Number(root.dataset.maxPhotoBytes) || 10 * 1024 * 1024;
    const maxTotalBytes = Number(root.dataset.maxTotalBytes) || 40 * 1024 * 1024;
    const allowHeic = root.dataset.allowHeic === 'true';
    const currentYear = Number(root.dataset.currentYear) || new Date().getFullYear();
    const steps = Array.from(form.querySelectorAll('[data-step]'));
    const progressItems = Array.from(root.querySelectorAll('[data-progress-item]'));
    const globalError = root.querySelector('[data-global-error]');
    const success = root.querySelector('[data-success]');
    const submitButton = form.querySelector('[data-submit]');
    const photoInput = form.querySelector('[data-photo-input]');
    const previewList = form.querySelector('[data-photo-previews]');
    const dropzone = form.querySelector('[data-dropzone]');
    const meter = form.querySelector('[data-upload-meter]');
    const uploadBar = form.querySelector('[data-upload-bar]');
    const uploadStatus = form.querySelector('[data-upload-status]');
    const reviewSummary = form.querySelector('[data-review-summary]');
    const idempotencyInput = form.querySelector('[data-idempotency-key]');
    const phoneInput = form.querySelector('[data-phone]');
    const phoneE164 = form.querySelector('[data-phone-e164]');
    const phoneDisplay = form.querySelector('[data-phone-display]');
    const priceInput = form.querySelector('[data-price-input]');
    const priceCanonical = form.querySelector('[data-price-canonical]');
    const priceUnsure = form.querySelector('[data-price-unsure]');
    const currency = form.querySelector('[data-currency]');
    const yearInput = form.querySelector('[data-year]');
    const yearUnknown = form.querySelector('[data-year-unknown]');
    const brandInput = form.querySelector('[data-brand]');
    const otherBrandWrap = form.querySelector('[data-other-brand-wrap]');
    const otherBrandInput = otherBrandWrap?.querySelector('input');
    const notes = form.querySelector('[data-notes]');
    const notesCount = form.querySelector('[data-notes-count]');
    const antiBot = form.querySelector('[data-antibot]');
    let currentStep = 1;
    let maxVisited = 1;
    let isSubmitting = false;
    let photos = [];
    let lastPayloadSignature = '';
    let disabledBeforeSubmit = null;
    let pendingFileProcessing = Promise.resolve();
    let fileProcessingDepth = 0;
    let fileProcessingButtonStates = null;
    let turnstileWidgetId = null;
    let turnstileRenderAttempts = 0;
    let antiBotWidgetReady = localPreview;

    const integrationIsReady = () => endpointIsSafe
      && privacyConfigured
      && (localPreview || (antiBotConfigured && antiBotWidgetReady));

    const refreshSubmitAvailability = () => {
      submitButton.disabled = isSubmitting || fileProcessingDepth > 0 || !integrationIsReady();
    };

    idempotencyInput.value = makeIdempotencyKey();

    const appendDescribedBy = (element, id) => {
      if (!element || !id) return;
      const ids = new Set((element.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
      ids.add(id);
      element.setAttribute('aria-describedby', Array.from(ids).join(' '));
    };

    form.querySelectorAll('[data-error-for]').forEach((error, index) => {
      const name = error.dataset.errorFor;
      if (!error.id) error.id = `${form.id}-field-error-${index + 1}`;
      const field = form.elements.namedItem(name);
      if (field instanceof RadioNodeList) {
        appendDescribedBy(form.querySelector(`[data-required-group="${escapeSelector(name)}"]`), error.id);
      } else {
        appendDescribedBy(field, error.id);
      }
    });

    const fieldError = (name) => form.querySelector(`[data-error-for="${escapeSelector(name)}"]`);

    const clearFieldError = (fieldOrName) => {
      const name = typeof fieldOrName === 'string' ? fieldOrName : fieldOrName?.name;
      const field = name ? form.elements.namedItem(name) : fieldOrName;
      const error = name ? fieldError(name) : null;
      if (error) error.textContent = '';
      if (field instanceof RadioNodeList) Array.from(field).forEach((item) => item.removeAttribute('aria-invalid'));
      else field?.removeAttribute?.('aria-invalid');
      if (name === 'photos') dropzone.removeAttribute('aria-invalid');
      if (name === 'cf-turnstile-response') antiBot?.removeAttribute('aria-invalid');
      field?.setCustomValidity?.('');
    };

    const setFieldError = (name, message) => {
      const field = form.elements.namedItem(name)
        || (name === 'photos' ? photoInput : null)
        || (name === 'cf-turnstile-response' ? antiBot : null);
      const error = fieldError(name);
      if (error) error.textContent = message;
      if (field instanceof RadioNodeList) Array.from(field).forEach((item) => item.setAttribute('aria-invalid', 'true'));
      else {
        field?.setAttribute?.('aria-invalid', 'true');
        field?.setCustomValidity?.(message);
      }
      if (name === 'photos') {
        dropzone.setAttribute('aria-invalid', 'true');
        appendDescribedBy(dropzone, error?.id);
        dropzone.tabIndex = -1;
        return dropzone;
      }
      if (name === 'cf-turnstile-response' && antiBot) {
        antiBot.setAttribute('aria-invalid', 'true');
        return antiBot;
      }
      return field instanceof RadioNodeList ? field[0] : field;
    };

    const showGlobalError = (message) => {
      globalError.textContent = message;
      globalError.hidden = false;
      globalError.focus({ preventScroll: true });
    };

    const clearGlobalError = () => {
      globalError.hidden = true;
      globalError.textContent = '';
    };

    const getRadioValue = (name) => form.querySelector(`input[name="${escapeSelector(name)}"]:checked`)?.value || '';
    const getRadioDisplay = (name) => {
      const selected = form.querySelector(`input[name="${escapeSelector(name)}"]:checked`);
      if (!selected) return null;
      const label = selected.closest('label');
      return (label.querySelector('strong') || label.querySelector('span')).textContent;
    };

    const validatePhone = () => {
      clearFieldError(phoneInput);
      phoneE164.value = '';
      phoneDisplay.value = '';
      const raw = phoneInput.value.trim();
      if (!raw) return { valid: false, field: setFieldError('phone_entered', nativeText('validation_phone_required')) };
      if (/[A-Za-z]/.test(raw)) return { valid: false, field: setFieldError('phone_entered', nativeText('validation_phone_characters')) };
      if (!window.libphonenumber || typeof window.libphonenumber.parsePhoneNumberFromString !== 'function') {
        return { valid: false, field: setFieldError('phone_entered', nativeText('validation_phone_unavailable')) };
      }
      const countryCode = form.querySelector('[data-country-code]').value || undefined;
      try {
        const parsed = window.libphonenumber.parsePhoneNumberFromString(raw, countryCode);
        if (!parsed || !parsed.isValid()) return { valid: false, field: setFieldError('phone_entered', nativeText('validation_phone_international')) };
        phoneE164.value = parsed.number;
        phoneDisplay.value = parsed.formatInternational();
        return { valid: true };
      } catch (_error) {
        return { valid: false, field: setFieldError('phone_entered', nativeText('validation_phone_invalid')) };
      }
    };

    const validateStep = (stepNumber) => {
      clearGlobalError();
      const step = steps[stepNumber - 1];
      let firstInvalid = null;
      step.querySelectorAll('[aria-invalid="true"]').forEach((element) => element.removeAttribute('aria-invalid'));
      step.querySelectorAll('.gml-field__error').forEach((element) => { element.textContent = ''; });

      const mark = (name, message) => {
        const field = setFieldError(name, message);
        if (!firstInvalid && field) firstInvalid = field;
      };

      if (stepNumber === 1) {
        const selectedBrand = BRANDS.find((brand) => normalize(brand) === normalize(brandInput.value));
        if (!brandInput.value.trim()) mark('brand', nativeText('validation_brand_required'));
        else if (!selectedBrand) mark('brand', nativeText('validation_brand_listed'));
        if (selectedBrand === 'Other' && !otherBrandInput.value.trim()) mark('brand_other', nativeText('validation_brand_other_required'));
        if (!form.elements.model.value.trim()) mark('model', nativeText('validation_model_required'));
        if (yearInput.value && !yearUnknown.checked) {
          const year = Number(yearInput.value);
          if (!Number.isInteger(year) || year < 1900 || year > currentYear) mark('year', nativeText('validation_year_range', { year: currentYear }));
        }
        ['condition', 'original_box', 'original_papers'].forEach((name) => {
          if (!getRadioValue(name)) mark(name, nativeText('validation_choice_required'));
        });
        if (priceUnsure.checked) {
          priceCanonical.value = '';
        } else {
          const canonical = canonicalizePrice(priceInput.value);
          if (!canonical) mark('expected_price_raw', nativeText('validation_price_required'));
          else priceCanonical.value = canonical;
        }
      }

      if (stepNumber === 2 && photos.length < 1) mark('photos', nativeText('validation_photo_required'));

      if (stepNumber === 3) {
        const name = form.elements.full_name;
        const email = form.elements.email;
        const country = form.elements.country;
        const countryCode = form.querySelector('[data-country-code]');
        const consent = form.elements.contact_consent;
        if (!name.value.trim()) mark('full_name', nativeText('validation_name_required'));
        if (!email.value.trim()) mark('email', nativeText('validation_email_required'));
        else if (!email.checkValidity()) mark('email', nativeText('validation_email_invalid'));
        if (!country.value.trim() || !countryCode.value) mark('country', nativeText('validation_country_required'));
        const phoneResult = validatePhone();
        if (!phoneResult.valid && !firstInvalid) firstInvalid = phoneResult.field;
        if (!getRadioValue('preferred_contact')) mark('preferred_contact', nativeText('validation_contact_required'));
        if (!consent.checked) mark('contact_consent', nativeText('validation_consent_required'));
        if (!localPreview && antiBotConfigured) {
          const antiBotToken = form.elements.namedItem('cf-turnstile-response')?.value?.trim();
          if (!antiBotToken) mark('cf-turnstile-response', nativeText('validation_security_required'));
        }
      }

      if (firstInvalid) {
        showGlobalError(nativeText('validation_review_highlighted'));
        window.setTimeout(() => firstInvalid.focus(), 0);
        return false;
      }
      return true;
    };

    const updateProgress = () => {
      progressItems.forEach((item, index) => {
        const stepNumber = index + 1;
        const button = item.querySelector('button');
        item.classList.toggle('is-current', stepNumber === currentStep);
        item.classList.toggle('is-complete', stepNumber < currentStep || (stepNumber < maxVisited && stepNumber !== currentStep));
        button.disabled = stepNumber > maxVisited;
        if (stepNumber === currentStep) button.setAttribute('aria-current', 'step');
        else button.removeAttribute('aria-current');
      });
    };

    const updateReview = () => {
      const brand = normalize(brandInput.value) === 'other' ? otherBrandInput.value.trim() || nativeText('choices_other_brand') : brandInput.value.trim();
      const price = priceUnsure.checked ? nativeText('review_guidance') : `${currency.value} ${priceInput.value.trim() || '—'}`;
      const values = [
        [nativeText('review_watch'), [brand, form.elements.model.value.trim()].filter(Boolean).join(' ') || '—'],
        [nativeText('review_reference'), form.elements.reference_number.value.trim() || nativeText('review_not_provided')],
        [nativeText('review_year'), yearUnknown.checked ? nativeText('choices_not_sure') : form.elements.year.value || nativeText('review_not_provided')],
        [nativeText('review_condition'), getRadioDisplay('condition') ?? '—'],
        [nativeText('review_box_papers'), `${getRadioDisplay('original_box') ?? '—'} / ${getRadioDisplay('original_papers') ?? '—'}`],
        [nativeText('review_accessories'), form.elements.accessories.value.trim() || nativeText('review_not_provided')],
        [nativeText('review_service'), form.elements.service_history.value.trim() || nativeText('review_not_provided')],
        [nativeText('review_price'), price],
        [nativeText('review_photos'), nativeText('review_photo_count', { count: photos.length })],
        [nativeText('review_seller'), form.elements.full_name.value.trim() || nativeText('review_complete_below')],
        [nativeText('review_email'), form.elements.email.value.trim() || nativeText('review_complete_below')],
        [nativeText('review_country'), form.querySelector('[data-country-input]').dataset.countryLabel || nativeText('review_complete_below')],
        [nativeText('review_city'), form.elements.city_region.value.trim() || nativeText('review_not_provided')],
        [nativeText('review_phone'), phoneDisplay.value || form.elements.phone_entered.value.trim() || nativeText('review_complete_below')],
        [nativeText('review_preferred_contact'), getRadioDisplay('preferred_contact') ?? nativeText('contact_email')],
        [nativeText('review_notes'), form.elements.additional_information.value.trim() || nativeText('review_not_provided')]
      ];
      reviewSummary.replaceChildren();
      values.forEach(([term, description]) => {
        const group = document.createElement('div');
        const dt = document.createElement('dt');
        const dd = document.createElement('dd');
        dt.textContent = term;
        dd.textContent = description;
        group.append(dt, dd);
        reviewSummary.append(group);
      });
    };

    const showStep = (stepNumber, focusHeading = true) => {
      currentStep = Math.max(1, Math.min(stepNumber, steps.length));
      maxVisited = Math.max(maxVisited, currentStep);
      steps.forEach((step, index) => { step.hidden = index + 1 !== currentStep; });
      updateProgress();
      clearGlobalError();
      if (currentStep === 3) updateReview();
      if (focusHeading) {
        const heading = steps[currentStep - 1].querySelector('.gml-sell__step-heading');
        heading.focus({ preventScroll: true });
        heading.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      }
    };

    const country = initCountryCombobox(root, () => {
      clearFieldError('country');
      phoneE164.value = '';
      phoneDisplay.value = '';
      updateReview();
    });

    const toggleOtherBrand = () => {
      const selectedBrand = BRANDS.find((brand) => normalize(brand) === normalize(brandInput.value));
      if (selectedBrand) brandInput.value = selectedBrand;
      const isOther = selectedBrand === 'Other';
      otherBrandWrap.hidden = !isOther;
      otherBrandInput.disabled = !isOther;
      otherBrandInput.required = isOther;
      if (!isOther) {
        otherBrandInput.value = '';
        clearFieldError('brand_other');
      }
    };

    const toggleYear = () => {
      yearInput.disabled = yearUnknown.checked;
      if (yearUnknown.checked) {
        yearInput.value = '';
        clearFieldError('year');
      }
    };

    const togglePrice = () => {
      priceInput.disabled = priceUnsure.checked;
      currency.disabled = priceUnsure.checked;
      priceInput.required = !priceUnsure.checked;
      if (priceUnsure.checked) {
        priceInput.value = '';
        priceCanonical.value = '';
        clearFieldError('expected_price_raw');
      }
      updateReview();
    };

    const renderPhotos = () => {
      previewList.replaceChildren();
      photos.forEach((entry, index) => {
        const item = document.createElement('li');
        item.className = 'gml-upload__preview';
        const media = document.createElement('div');
        media.className = 'gml-upload__preview-media';
        if (entry.type === 'heic') {
          const placeholder = document.createElement('span');
          placeholder.textContent = nativeText('photos_heic_label');
          media.append(placeholder);
        } else {
          const image = document.createElement('img');
          image.src = entry.url;
          image.alt = nativeText('photos_selected_alt', { index: index + 1, name: entry.file.name });
          media.append(image);
        }
        const copy = document.createElement('div');
        copy.className = 'gml-upload__preview-copy';
        const name = document.createElement('strong');
        name.textContent = entry.file.name;
        const size = document.createElement('span');
        size.textContent = formatBytes(entry.file.size);
        copy.append(name, size);
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.setAttribute('aria-label', nativeText('photos_remove_label', { name: entry.file.name }));
        remove.textContent = nativeText('photos_remove');
        remove.addEventListener('click', () => {
          if (isSubmitting) return;
          if (entry.url) URL.revokeObjectURL(entry.url);
          photos = photos.filter((photo) => photo.id !== entry.id);
          renderPhotos();
          updateReview();
        });
        item.append(media, copy, remove);
        previewList.append(item);
      });
    };

    const addFiles = async (fileList) => {
      if (isSubmitting) return;
      clearFieldError('photos');
      const incoming = Array.from(fileList || []);
      if (!incoming.length) return;
      const rejections = [];
      const seenKeys = new Set(photos.map((entry) => `${entry.file.name}:${entry.file.size}:${entry.file.lastModified}`));
      const candidates = [];
      incoming.forEach((file) => {
        const key = `${file.name}:${file.size}:${file.lastModified}`;
        if (seenKeys.has(key)) rejections.push(nativeText('photos_duplicate', { name: file.name }));
        else {
          seenKeys.add(key);
          candidates.push(file);
        }
      });

      const validated = [];
      for (const file of candidates) {
        if (file.size <= 0) {
          rejections.push(nativeText('photos_empty', { name: file.name }));
          continue;
        }
        if (file.size > maxPhotoBytes) {
          rejections.push(nativeText('photos_too_large', { name: file.name, limit: formatBytes(maxPhotoBytes) }));
          continue;
        }
        let type;
        try {
          type = await detectImageType(file);
        } catch (_error) {
          type = null;
        }
        if (!type || (!['jpeg', 'png', 'webp'].includes(type) && !(allowHeic && type === 'heic'))) {
          const heicLabel = allowHeic ? nativeText('photos_heic_supported').trim() : '';
          rejections.push(nativeText('photos_invalid_image', { name: file.name, heic: heicLabel ? ' ' + heicLabel : '' }));
          continue;
        }
        if (type !== 'heic' && !(await imageDecodes(file))) {
          rejections.push(nativeText('photos_decode_failed', { name: file.name }));
          continue;
        }
        validated.push({ file, type });
      }

      let acceptedCount = photos.length;
      let acceptedBytes = photos.reduce((sum, entry) => sum + entry.file.size, 0);
      validated.forEach(({ file, type }) => {
        if (acceptedCount >= maxPhotos) {
          rejections.push(nativeText('photos_count_limit', { name: file.name, limit: maxPhotos }));
          return;
        }
        if (acceptedBytes + file.size > maxTotalBytes) {
          rejections.push(nativeText('photos_total_limit', { name: file.name, limit: formatBytes(maxTotalBytes) }));
          return;
        }
        const url = type === 'heic' ? '' : URL.createObjectURL(file);
        photos.push({ id: makeIdempotencyKey(), file, type, url });
        acceptedCount += 1;
        acceptedBytes += file.size;
      });
      if (rejections.length) setFieldError('photos', rejections.join(' '));
      photoInput.value = '';
      renderPhotos();
      updateReview();
    };

    const queueFiles = (fileList) => {
      const queuedFiles = Array.from(fileList || []);
      if (!queuedFiles.length || isSubmitting) return pendingFileProcessing;
      fileProcessingDepth += 1;
      if (fileProcessingDepth === 1) {
        fileProcessingButtonStates = new Map();
        root.querySelectorAll('[data-next], [data-back], [data-step-jump], [data-edit-details], [data-submit]').forEach((button) => {
          fileProcessingButtonStates.set(button, button.disabled);
          button.disabled = true;
        });
        dropzone.setAttribute('aria-busy', 'true');
        meter.hidden = false;
        uploadBar.style.width = '0%';
        uploadStatus.textContent = nativeText('status_checking_photos');
      }
      const processBatch = async () => {
        try {
          await addFiles(queuedFiles);
        } catch (_error) {
          setFieldError('photos', nativeText('validation_photo_check_failed'));
        }
      };
      pendingFileProcessing = pendingFileProcessing.then(processBatch, processBatch).finally(() => {
        fileProcessingDepth -= 1;
        if (fileProcessingDepth === 0) {
          fileProcessingButtonStates?.forEach((wasDisabled, button) => { button.disabled = wasDisabled; });
          fileProcessingButtonStates = null;
          refreshSubmitAvailability();
          dropzone.removeAttribute('aria-busy');
          if (!isSubmitting) {
            meter.hidden = true;
            uploadBar.style.width = '0%';
            uploadStatus.textContent = '';
          }
        }
      });
      return pendingFileProcessing;
    };

    form.querySelectorAll('[data-next]').forEach((button) => button.addEventListener('click', async () => {
      await pendingFileProcessing;
      if (validateStep(currentStep)) showStep(currentStep + 1);
    }));
    form.querySelectorAll('[data-back]').forEach((button) => button.addEventListener('click', () => showStep(currentStep - 1)));
    root.querySelectorAll('[data-step-jump]').forEach((button) => button.addEventListener('click', () => {
      const target = Number(button.dataset.stepJump);
      if (target <= maxVisited) showStep(target);
    }));
    form.querySelector('[data-edit-details]')?.addEventListener('click', () => showStep(1));

    brandInput.addEventListener('input', toggleOtherBrand);
    brandInput.addEventListener('change', toggleOtherBrand);
    yearUnknown.addEventListener('change', toggleYear);
    priceUnsure.addEventListener('change', togglePrice);
    const updateNotesCount = () => {
      notesCount.textContent = notes.value.length.toLocaleString(document.documentElement.lang || 'en') + '/' + notes.maxLength.toLocaleString(document.documentElement.lang || 'en');
      notesCount.dataset.limitReached = String(notes.value.length >= notes.maxLength);
    };
    notes.addEventListener('input', updateNotesCount);
    form.addEventListener('reset', () => requestAnimationFrame(updateNotesCount));
    updateNotesCount();
    photoInput.addEventListener('change', () => {
      const selectedFiles = Array.from(photoInput.files || []);
      photoInput.value = '';
      queueFiles(selectedFiles);
    });
    ['dragenter', 'dragover'].forEach((eventName) => dropzone.addEventListener(eventName, (event) => {
      event.preventDefault();
      dropzone.classList.add('is-dragging');
    }));
    ['dragleave', 'drop'].forEach((eventName) => dropzone.addEventListener(eventName, (event) => {
      event.preventDefault();
      dropzone.classList.remove('is-dragging');
    }));
    dropzone.addEventListener('drop', (event) => queueFiles(event.dataTransfer.files));

    form.addEventListener('input', (event) => {
      if (event.target.name && event.target !== photoInput) clearFieldError(event.target);
      if (event.target === phoneInput) {
        phoneE164.value = '';
        phoneDisplay.value = '';
      }
      if (event.target === phoneInput && /[A-Za-z]/.test(phoneInput.value)) {
        setFieldError('phone_entered', nativeText('validation_phone_characters'));
      }
      if (currentStep === 3) updateReview();
    });
    form.addEventListener('change', (event) => {
      if (event.target.name && event.target !== photoInput) clearFieldError(event.target);
      if (currentStep === 3) updateReview();
    });

    const applyServerErrors = (fieldErrors) => {
      if (!fieldErrors || typeof fieldErrors !== 'object') return false;
      let firstField = null;
      let targetStep = 3;
      Object.entries(fieldErrors).forEach(([name, message]) => {
        if (typeof message !== 'string') return;
        const field = setFieldError(name, message);
        if (!firstField && field) firstField = field;
        const holder = field?.closest?.('[data-step]');
        if (holder) targetStep = Math.min(targetStep, Number(holder.dataset.step));
      });
      if (firstField) {
        showStep(targetStep, false);
        showGlobalError(nativeText('validation_review_retry'));
        firstField.focus();
        return true;
      }
      return false;
    };

    const setSubmitting = (submitting) => {
      isSubmitting = submitting;
      form.setAttribute('aria-busy', String(submitting));
      if (submitting) {
        disabledBeforeSubmit = new Map();
        root.querySelectorAll('button, input, select, textarea').forEach((control) => {
          disabledBeforeSubmit.set(control, control.disabled);
          control.disabled = true;
        });
      } else if (disabledBeforeSubmit) {
        disabledBeforeSubmit.forEach((wasDisabled, control) => { control.disabled = wasDisabled; });
        disabledBeforeSubmit = null;
      }
      refreshSubmitAvailability();
      submitButton.classList.toggle('is-loading', submitting);
      meter.hidden = !submitting;
      if (!submitting) {
        uploadBar.style.width = '0%';
        uploadStatus.textContent = '';
      }
    };

    const endpointChild = (child) => {
      const url = new URL(endpointUrl.href);
      url.pathname = `${url.pathname.replace(/\/$/, '')}/${child}`;
      return url.href;
    };

    const collectFields = () => {
      const values = {};
      const data = new FormData(form);
      data.delete('photos');
      data.delete('cf-turnstile-response');
      data.delete('idempotency_key');
      data.forEach((value, key) => {
        if (value instanceof File) return;
        if (Object.prototype.hasOwnProperty.call(values, key)) {
          values[key] = Array.isArray(values[key]) ? [...values[key], value] : [values[key], value];
        } else {
          values[key] = value;
        }
      });
      const selectedCountry = COUNTRIES.find(country => country.code === values.country_code);
      if (selectedCountry) values.country = selectedCountry.name;
      return values;
    };

    const photoManifest = (photoEntries) => photoEntries.map((entry, index) => ({
      clientId: entry.id,
      order: index + 1,
      fileName: entry.file.name,
      declaredBytes: entry.file.size,
      detectedType: entry.type,
      lastModified: entry.file.lastModified
    }));

    const requestJson = async (url, body, timeoutMs = 45000) => {
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), timeoutMs);
      try {
        const response = await fetch(url, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Idempotency-Key': idempotencyInput.value,
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(body),
          signal: controller.signal
        });
        let responseBody = null;
        try { responseBody = await response.json(); } catch (_error) { responseBody = null; }
        if (!response.ok) {
          const error = new Error('Request rejected');
          error.status = response.status;
          error.body = responseBody;
          throw error;
        }
        return { status: response.status, body: responseBody };
      } finally {
        window.clearTimeout(timeout);
      }
    };

    const safeUploadUrl = (value) => {
      try {
        const url = new URL(value);
        if (url.protocol === 'https:') return url;
        if (localPreview && url.protocol === 'http:' && ['localhost', '127.0.0.1', '[::1]'].includes(url.hostname)) return url;
      } catch (_error) {
        return null;
      }
      return null;
    };

    const uploadPhoto = (plan, entry, onProgress) => new Promise((resolve, reject) => {
      const uploadUrl = safeUploadUrl(plan.url);
      if (!uploadUrl || !plan.fields || typeof plan.fields !== 'object' || Array.isArray(plan.fields)) {
        reject(Object.assign(new Error('The secure upload grant was invalid.'), { displayMessage: nativeText('uploads_invalid_grant') }));
        return;
      }
      const uploadData = new FormData();
      Object.entries(plan.fields).forEach(([key, value]) => uploadData.append(key, String(value)));
      uploadData.append('file', entry.file, entry.file.name);
      const request = new XMLHttpRequest();
      request.open('POST', uploadUrl.href, true);
      request.upload.addEventListener('progress', (progressEvent) => {
        onProgress(progressEvent.lengthComputable ? Math.min(entry.file.size, progressEvent.loaded) : 0);
      });
      request.addEventListener('load', () => {
        if ([200, 201, 204].includes(request.status)) resolve();
        else reject(Object.assign(new Error(`Photo upload was rejected (${request.status || 'network error'}).`), { displayMessage: nativeText('uploads_rejected', { status: request.status || nativeText('uploads_network_status') }) }));
      });
      request.addEventListener('error', () => reject(Object.assign(new Error('A network error interrupted a photo upload.'), { displayMessage: nativeText('uploads_network') })));
      request.addEventListener('timeout', () => reject(Object.assign(new Error('A photo upload timed out.'), { displayMessage: nativeText('uploads_timeout') })));
      request.timeout = 300000;
      request.send(uploadData);
    });

    const isDurableSuccess = (status, body) => {
      const deliveryStates = ['queued', 'pending', 'delivered', 'failed'];
      return [200, 201].includes(status)
        && body?.ok === true
        && typeof body.reference === 'string'
        && body.reference.trim()
        && typeof body.savedAt === 'string'
        && !Number.isNaN(Date.parse(body.savedAt))
        && deliveryStates.includes(body.deliveryStatus);
    };

    const waitForDurableResult = async (initial, session) => {
      if (isDurableSuccess(initial.status, initial.body)) return initial;
      if (initial.status !== 202) return initial;
      const retryMs = Math.min(5000, Math.max(1000, Number(initial.body?.retryAfterMs) || 2000));
      for (let attempt = 0; attempt < 8; attempt += 1) {
        await new Promise((resolve) => window.setTimeout(resolve, retryMs));
        const statusResult = await requestJson(endpointChild('status'), session);
        if (isDurableSuccess(statusResult.status, statusResult.body)) return statusResult;
        if (statusResult.status !== 202) return statusResult;
      }
      const error = new Error('Processing is still in progress.');
      error.status = 202;
      error.body = { message: nativeText('errors_saving_unconfirmed') };
      throw error;
    };

    const renderAntiBot = () => {
      if (!antiBotConfigured || localPreview || !antiBot || turnstileWidgetId !== null) return;
      const container = antiBot.querySelector('[data-turnstile-container]');
      if (!container) return;
      if (!window.turnstile || typeof window.turnstile.render !== 'function') {
        turnstileRenderAttempts += 1;
        if (turnstileRenderAttempts < 100) window.setTimeout(renderAntiBot, 100);
        else {
          antiBotWidgetReady = false;
          setFieldError('cf-turnstile-response', nativeText('validation_security_load_failed'));
          refreshSubmitAvailability();
        }
        return;
      }
      try {
        const renderedWidgetId = window.turnstile.render(container, {
          sitekey: container.dataset.sitekey,
          action: 'sell_watch_quote',
          theme: 'light',
          callback: () => {
            antiBotWidgetReady = true;
            clearFieldError('cf-turnstile-response');
            refreshSubmitAvailability();
          },
          'expired-callback': () => setFieldError('cf-turnstile-response', nativeText('validation_security_expired')),
          'error-callback': () => {
            antiBotWidgetReady = false;
            setFieldError('cf-turnstile-response', nativeText('validation_security_load_failed'));
            refreshSubmitAvailability();
          }
        });
        if (typeof renderedWidgetId !== 'string' || !renderedWidgetId) throw new Error('Turnstile did not return a widget ID.');
        turnstileWidgetId = renderedWidgetId;
        antiBotWidgetReady = true;
        refreshSubmitAvailability();
      } catch (_error) {
        antiBotWidgetReady = false;
        setFieldError('cf-turnstile-response', nativeText('validation_security_start_failed'));
        refreshSubmitAvailability();
      }
    };

    const resetAntiBot = () => {
      if (!antiBotConfigured || !window.turnstile || turnstileWidgetId === null) return;
      try { window.turnstile.reset(turnstileWidgetId); } catch (_error) { /* no-op */ }
    };

    const showSuccess = (body) => {
      uploadBar.style.width = '100%';
      uploadStatus.textContent = nativeText('status_saved');
      form.hidden = true;
      root.querySelector('.gml-sell__progress').hidden = true;
      root.querySelector('[data-success-reference]').textContent = body.reference;
      const delivery = root.querySelector('[data-success-delivery]');
      delivery.textContent = body.deliveryStatus === 'delivered'
        ? nativeText('status_delivery_accepted')
        : body.deliveryStatus === 'failed'
          ? nativeText('status_delivery_failed')
          : nativeText('status_delivery_pending');
      success.hidden = false;
      success.focus();
      photos.forEach((entry) => { if (entry.url) URL.revokeObjectURL(entry.url); });
      photos = [];
    };

    const handleSubmissionError = (error) => {
      setSubmitting(false);
      resetAntiBot();
      const body = error?.body;
      if (applyServerErrors(body?.fieldErrors)) return;
      let message = typeof body?.message === 'string'
        ? body.message
        : nativeText('errors_save_failed');
      if (error?.name === 'AbortError') message = nativeText('errors_service_timeout');
      if (error?.status === 413) message = nativeText('errors_upload_too_large');
      if (error?.status === 429) message = nativeText('errors_too_many_attempts');
      if ([401, 403].includes(error?.status)) message = nativeText('errors_connection_unverified');
      if (error?.status === 409 && body?.code === 'IDEMPOTENCY_CONFLICT') {
        idempotencyInput.value = makeIdempotencyKey();
        lastPayloadSignature = '';
        message = nativeText('errors_request_changed');
      }
      if (!body?.message && error?.message && /photo upload|upload grant/i.test(error.message)) message = nativeText('uploads_retry', { message: typeof error.displayMessage === 'string' ? error.displayMessage : error.message });
      showGlobalError(message);
    };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (isSubmitting) return;
      await pendingFileProcessing;
      if (isSubmitting) return;
      if (!integrationIsReady()) {
        showGlobalError(nativeText('errors_connection_incomplete'));
        return;
      }
      if (!validateStep(1)) { showStep(1, false); showGlobalError(nativeText('validation_review_highlighted')); return; }
      if (!validateStep(2)) { showStep(2, false); showGlobalError(nativeText('validation_review_highlighted')); return; }
      if (!validateStep(3)) { showStep(3, false); showGlobalError(nativeText('validation_review_highlighted')); return; }

      updateReview();
      clearGlobalError();
      const fields = collectFields();
      const submissionPhotos = [...photos];
      const manifest = photoManifest(submissionPhotos);
      const payloadSignature = JSON.stringify({ schemaVersion: '2026-09-25', fields, photos: manifest });
      if (lastPayloadSignature && lastPayloadSignature !== payloadSignature) idempotencyInput.value = makeIdempotencyKey();
      lastPayloadSignature = payloadSignature;
      const antiBotToken = localPreview ? 'LOCAL-PREVIEW-ONLY' : form.elements.namedItem('cf-turnstile-response')?.value?.trim();
      setSubmitting(true);
      uploadStatus.textContent = nativeText('status_creating_session');

      try {
        const bootstrapResult = await requestJson(endpointChild('bootstrap'), {
          schemaVersion: '2026-09-25',
          submissionKey: idempotencyInput.value,
          antiBotToken,
          clientSubmittedAt: new Date().toISOString(),
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || '',
          fields,
          photos: manifest
        });
        const bootstrap = bootstrapResult.body;
        if (
          ![200, 201].includes(bootstrapResult.status)
          || bootstrap?.ok !== true
          || typeof bootstrap.sessionId !== 'string'
          || typeof bootstrap.sessionToken !== 'string'
          || !Array.isArray(bootstrap.uploads)
          || bootstrap.uploads.length !== submissionPhotos.length
        ) throw new Error('The secure service returned an invalid upload session.');

        const planByClientId = new Map();
        bootstrap.uploads.forEach((plan) => {
          if (typeof plan?.clientId !== 'string' || typeof plan?.photoId !== 'string' || planByClientId.has(plan.clientId)) {
            throw new Error('The secure service returned an invalid photo plan.');
          }
          planByClientId.set(plan.clientId, plan);
        });
        if (submissionPhotos.some((entry) => !planByClientId.has(entry.id))) throw new Error('The secure service did not prepare every selected photo.');

        let completedBytes = 0;
        const totalBytes = submissionPhotos.reduce((sum, entry) => sum + entry.file.size, 0);
        for (let index = 0; index < submissionPhotos.length; index += 1) {
          const entry = submissionPhotos[index];
          const plan = planByClientId.get(entry.id);
          if (plan.status === 'uploaded') {
            completedBytes += entry.file.size;
            continue;
          }
          if (plan.status !== 'pending') throw new Error('The secure service returned an unsupported upload state.');
          uploadStatus.textContent = nativeText('status_uploading', { index: index + 1, total: submissionPhotos.length });
          await uploadPhoto(plan, entry, (loaded) => {
            const percent = Math.min(96, Math.round(((completedBytes + loaded) / totalBytes) * 96));
            uploadBar.style.width = `${percent}%`;
            uploadStatus.textContent = nativeText('status_uploading_progress', { index: index + 1, total: submissionPhotos.length, percent });
          });
          completedBytes += entry.file.size;
        }

        uploadBar.style.width = '97%';
        uploadStatus.textContent = nativeText('status_saving');
        const session = {
          submissionKey: idempotencyInput.value,
          sessionId: bootstrap.sessionId,
          sessionToken: bootstrap.sessionToken
        };
        const finalizeResult = await requestJson(endpointChild('finalize'), {
          ...session,
          photoIds: submissionPhotos.map((entry) => planByClientId.get(entry.id).photoId)
        }, 60000);
        const durableResult = await waitForDurableResult(finalizeResult, session);
        if (!isDurableSuccess(durableResult.status, durableResult.body)) throw new Error('The request was not confirmed as saved.');
        showSuccess(durableResult.body);
      } catch (error) {
        handleSubmissionError(error);
      }
    });

    toggleOtherBrand();
    toggleYear();
    togglePrice();
    updateProgress();
    renderPhotos();
    country?.close();
    form.removeAttribute('inert');
    form.removeAttribute('aria-disabled');
    setSubmitting(false);
    renderAntiBot();
    if (endpoint && !endpointIsSafe) {
      showGlobalError(nativeText('errors_connection_misconfigured'));
    } else if (endpointIsSafe && !antiBotConfigured && !localPreview) {
      showGlobalError(nativeText('errors_antibot_missing'));
    } else if (endpointIsSafe && !privacyConfigured) {
      showGlobalError(nativeText('errors_privacy_missing'));
    }
  }

  const initAll = (scope = document) => scope.querySelectorAll('[data-gml-sell]').forEach(initSection);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
